import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, TextField, Typography,
  DialogContent, DialogContentText, DialogActions, Alert,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Header from "../components/Header";

export default function ForgottenPassword() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (sent) {
      const timer = setTimeout(() => navigate("/connexion"), 3000);
      return () => clearTimeout(timer);
    }
  }, [sent, navigate]);

  const handleSend = async () => {
    setError("");
    try {
      const res = await fetch("/api/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ users_email: email }),
      });
      const data = await res.json();
      setSent(true);
      setMessage(data.message || "Si ce mail existe, tu recevras un lien de réinitialisation.");
    } catch {
      setError("Erreur lors de l'envoi. Réessaie plus tard.");
    }
  };

  return (
    <>
      <Header />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
        <Box sx={{
          backgroundColor: theme.custom.mymodal.main,
          color: theme.custom.mymodal.text,
          border: theme.custom.mymodal.border,
          borderRadius: "5px",
          width: "100%",
          maxWidth: 400,
        }}>
          <Typography sx={{ textAlign: "center", p: "8px", fontWeight: "bold",
            color: theme.custom.mymodal.text, backgroundColor: theme.custom.mymodal.button,
            borderRadius: "5px 5px 0 0", textTransform: "uppercase" }}>
            Mot de passe oublié
          </Typography>

          <DialogContent>
            {sent ? (
              <Alert severity="success" sx={{ mt: 1 }}>{message}<br />Redirection en cours…</Alert>
            ) : (
              <>
                <DialogContentText sx={{ color: theme.custom.mymodal.text, mb: 2 }}>
                  Indique ton adresse e-mail, tu recevras un lien pour réinitialiser ton mot de passe.
                </DialogContentText>
                <TextField label="Adresse e-mail" type="email" fullWidth value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter" && email) handleSend(); }} />
                {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
              </>
            )}
          </DialogContent>

          {!sent && (
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
              <Button onClick={handleSend} disabled={!email}
                sx={{ color: theme.custom.mymodal.text, backgroundColor: theme.custom.mymodal.button }}>
                Envoyer le lien
              </Button>
            </DialogActions>
          )}
        </Box>
      </Box>
    </>
  );
}
